<template>
    <div class="header">
        <!-- <div class="timebox">
            <div class="time1">{{ timeFormate() }}</div>
            <div class="time2">{{ state.nowTime }}</div>
        </div> -->
        <!-- <div class="headerMenuL">
            <div :class="['MenuBt', headerMenuFlag == menu.id ? 'leftMenuBtL' : 'leftMenuBt']"
                v-for="(menu, i) in headerMenuList.slice(0, 4)" :key="item" @click="headerMenuFun(menu.id)"
                :style="{ left: `-${i * 16}px` }">
                {{ menu.name }}
            </div>
        </div> -->
        <div class="headerTitle">{{ localTitle }}</div>
        <!-- <div class="headerMenuR">
            <div :class="['MenuBt', headerMenuFlag == menu.id ? 'rightMenuBtL' : 'rightMenuBt']"
                v-for="(menu, i) in headerMenuList.slice(4)" :key="item" @click="headerMenuFun(menu.id)"
                :style="{ right: `-${(3 - i) * 16}px` }">
                {{ menu.name }}
            </div>
        </div> -->
        <!-- <div class="leftMenuBox">
            <el-upload ref="upload" :before-upload="upload" :show-file-list="false" accept=".xlsx,.xls"
                style=" display: inline-flex;">
                <div class="leftMenuBt"> 导入文档 </div>
            </el-upload>
        </div> -->
    </div>
</template>

<script setup>
import '@/components/style.less'
import router from '@/router';

import { ref, reactive, computed, onMounted, onUnmounted } from 'vue';

const state = reactive({
    time: { hour: "", minitus: "", seconds: "", weekday: '' },
    weekAll: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
    nowTime: "",
    headerMenuList: [
        { name: '执勤车辆', id: 1 },
        { name: '人员实力', id: 2 },
        { name: '组织建设', id: 3 },
        { name: '一日生活', id: 4 },
        { name: '日常制度', id: 5 },
        { name: '执勤值班', id: 6 },
        { name: '训练培训', id: 7 },
        { name: '营区安全', id: 8 },
    ]
});
const { time, weekAll, nowTime, headerMenuList } = state

// 将父组件传递的props声明为参数
const props = defineProps({ title: String });
// 使用ref将props中的数据声明为响应式数据
const localTitle = ref(props.title);
const headerMenuFlag = ref(1);

// 在setup中计算一个衍生的响应式数据
const computedMessage = computed(() => 'Computed: ' + localMessage.value);
const doubleCount = computed(() => state.count * 2);

const upload = (file) => { }

onMounted(() => {
    // dateTime()
    if (!router.currentRoute.value.query.id) {
        headerMenuFlag.value = 1
        return
    }
    headerMenuFlag.value = router.currentRoute.value.query.id
});

onUnmounted(() => {
    // console.log('Component unmounted');
});

// 时间开始
const dateTime = () => {
    timeFormate();
    setTimeout(() => { dateTime() }, 1000);
};
const getIncrease = (num, digit) => {
    var increase = "";
    for (var i = 0; i < digit; i++) {
        increase += "0";
    }
    return (increase + num).slice(-digit);
};
const timeFormate = () => {
    const newtime = new Date();
    state.time.hour = getIncrease(newtime.getHours(), 2);
    state.time.minitus = getIncrease(newtime.getMinutes(), 2);
    state.time.seconds = getIncrease(newtime.getSeconds(), 2);
    state.time.weekday = state.weekAll[newtime.getDay()];
    state.nowTime = getIncrease(newtime.getFullYear(), 4) + "年" + getIncrease(newtime.getMonth() + 1, 2) + "月" + getIncrease(newtime.getDate(), 2) + "日" + " " + state.weekAll[newtime.getDay()];
    // `${time.hour}:${time.minitus}:${time.seconds}`
    return `${state.time.hour}:${state.time.minitus}:${state.time.seconds}`;
};
// 时间结束

const headerMenuFun = (v) => {
    if (v == 5 || v == 6) return
    headerMenuFlag.value = v;
    router.push({
        path: `/${v}`,
        query: {
            id: v
        }
    })
}

</script>

<style scoped>
/* 这里可以添加组件的样式 */
/* @import "@/components/style.less"; */
</style>
